import React from 'react'
import { useAuthContext } from './AppAuth'
import { useBaseConfigContext } from './AppBaseConfig'
import { useDeploymentContext } from './AppDeploymentProvider'
import { useTenantContext } from './AppTenant'
import { loadMSClarity, setMSClarityTag } from '../../shared/msClarity/msClarity'
import { getJwtClaim } from '../../shared/msClarity/jwtClaims'

const msClarityProjectId = process.env.REACT_APP_MS_CLARITY_PROJECT_ID ?? ''

const AppMSClarityTags = () => {
    const { token } = useAuthContext()
    const baseConfig = useBaseConfigContext()
    const tenant = useTenantContext()
    const { environment, instance } = useDeploymentContext()

    React.useEffect(() => {
        if (msClarityProjectId) {
            loadMSClarity(msClarityProjectId)
        }
    }, [])

    React.useEffect(() => {
        if (!msClarityProjectId) {
            return
        }

        setMSClarityTag('accessType', 'Go')
        setMSClarityTag('Version Number', baseConfig.version)
        setMSClarityTag('environmentIdentifier', environment)
        setMSClarityTag('instanceIdentifier', instance ?? '')
        setMSClarityTag('TenancyTLA', tenant.displayID)

        if (token) {
            const userID = getJwtClaim(token, 'userID')
            setMSClarityTag('UserID', userID)
        }
    }, [token, baseConfig.version, environment, instance, tenant.displayID])

    return null
}

export default AppMSClarityTags
